<template>
    <div class="container">
    <footer class="footer" data-component-name="Footer/Footer">
        
        <div class="enlacesFooter" v-if="!isMobile">
            <ul>
                <li><router-link class="fo-link" to="/">{{ $t('Home') }}</router-link></li>
                <li><router-link class="fo-link" to="/about">{{ $t('Who we are?') }}</router-link></li>
                <li><router-link class="fo-link" to="/services">{{ $t('Services') }}</router-link></li>
                <li><router-link class="fo-link" to="/works">{{ $t('Works') }}</router-link></li>
                <li><router-link class="fo-link" to="/contact">{{ $t('Contact us') }}</router-link></li>
                <li><router-link class="fo-link" to="/privacy-policy">{{ $t('Privacy Policy') }}</router-link></li>
                <li><router-link class="fo-link" to="/terms-of-service">{{ $t('Terms of Service') }}</router-link></li>
                <li><router-link class="fo-link" to="/cookies-policy">{{ $t('Cookies Policy') }}</router-link></li>
            </ul>
        </div>
        <div class="copyrightText">
            <p>© 2014 - {{ currentYear }} JLHSOFT TECHNOLOGY.</p>
            <div class="btn-group">
                <button class="btn btn-link btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-globe"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('en')"><img :src="imgen" alt="English" class="img_lang" width="16" height="11" /> {{ $t('English') }}</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('es')"><img :src="imges" alt="Español" class="img_lang" width="16" height="11" /> {{ $t('Spanish') }}</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('pt')"><img :src="imgbr" alt="Portugués" class="img_lang" width="16" height="11" /> {{ $t('Portuguese') }}</a></li>
                </ul>
            </div>
        </div>
    </footer>
</div>
</template>
<script>

import imgen from '../assets/lang/us.png';
import imges from '../assets/lang/es.png';
import imgbr from '../assets/lang/br.png';
export default {
name: "FooterBar",
data() {
    return {
        isMobile: false,
        imgen,
        imges,
        imgbr
    };
},
methods: {
    changeLanguage(lang) {
        this.$i18n.locale = lang;
    },
    handleResize() {
        this.isMobile = window.innerWidth <= 991; // Cambiar a móvil si la pantalla es menor o igual a 768px
    },
},
computed: {
    currentYear() {
    return new Date().getFullYear();
    },
},
mounted() {
this.handleResize(); // Verifica el tamaño inicial de la pantalla
window.addEventListener("resize", this.handleResize); // Escucha cambios en el tamaño
},
beforeUnmount() {
window.removeEventListener("resize", this.handleResize); // Limpia el listener al desmontar
},

}
</script>
<style scoped>
.footer {
    width: 100%;
    margin-bottom: 0;
    padding: calc(3px * 10) calc(3px * 8);
    flex-direction: column;
    -webkit-box-align: stretch;
    align-items: stretch;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
}
[data-component-name="Footer/Footer"] {
background-size: cover;
background-repeat: no-repeat;
background-position: bottom right;
}

.copyrightText{
width: 100%;
display: flex;
justify-content: center;
align-content: center;
}

.copyrightText p{
color: #fff;
font-size: 12px;
}
.btn-link{
margin-top: -18px;
text-decoration: none;
color: #fff;
}

.btn-link:hover{
color: #fff;
}
.btn-link.show{
color: #fff;
}
.enlacesFooter{
width: 100%;
display: flex;
justify-content: center;
align-items: center;
}
.enlacesFooter ul{
list-style: none;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
}
.enlacesFooter ul li{
font-size: 13px;
margin-right: 15px;
-webkit-transition: opacity .6s linear;
transition: opacity .6s linear;
}
.fo-link{
color: #fff;
display: block;
line-height: 1.4;
text-decoration: none;
position: relative;
-webkit-transition: color .25s ease;
transition: color .25s ease;
text-shadow: 0px 5px 15px rgb(15 36 84 / 5%);
}
.fo-link:hover{
color: #fff;
text-decoration: none;
}

.fo-link:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background: #fff;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: right center;
    transform-origin: right center;
    -webkit-transition: -webkit-transform .6s cubic-bezier(.19, 1, .22, 1);
    transition: -webkit-transform .6s cubic-bezier(.19, 1, .22, 1);
    transition: transform .6s cubic-bezier(.19, 1, .22, 1);
    transition: transform .6s cubic-bezier(.19, 1, .22, 1), -webkit-transform .6s cubic-bezier(.19, 1, .22, 1);
}

.fo-link:focus:after,
.fo-link:hover:after {
    -webkit-transition-duration: .4s;
    transition-duration: .4s;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transform-origin: left center;
    transform-origin: left center;
}
@media (max-width: 991px){
.footer{
    padding-bottom: 70px; /* Altura aproximada del navbar móvil */
}

}
</style>